import { FC } from 'react';
import {
    FormWithRedirect,
    // SaveButton,
    // DeleteButton,
    TextInput,
    required,
    email,
    useTranslate,
} from 'react-admin';
import {
    makeStyles,
    createStyles,
    Theme,
    Typography,
    // Toolbar,
    Grid,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
} from '@material-ui/core';
import { dateLocales, defaultDateOptions } from '../utils/formatters';
import { JsonInput } from "react-admin-json-view";
import { DateTimeInput } from '../components/DatePickers';
import { SemiControlledAccordion } from '../components/Accordion';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReferenceManyInput from '../components/ReferenceManyInput';
import MerchantBanks from './MerchantBanks';
import MerchantPhones from './MerchantPhones';
import MerchantDocs from './MerchantDocs';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fixed_fee: {},
        amount: { fontWeight: 'bold' },
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }),
);

const MerchantCommon: FC<{}> = (props: any) => {
    const classes = useStyles()
    const translate = useTranslate()

    // const resource = props.resource

    const isMedium = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('md')
    );

    return <FormWithRedirect
        {...props}
        render={formProps => {
            // console.log(formProps.record)
            return (
                // here starts the custom form layout
                <>
                    <Typography variant="h6">{translate("resources.common.fieldGroups.basicInfo")}</Typography>
                    <Grid container className={classes.root} spacing={2}>
                        <Grid item xs={12} sm={6} lg={6}>
                            <TextInput
                                source="external_id"
                                fullWidth
                                validate={[required()]}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                            <TextInput
                                source="name"
                                fullWidth
                                validate={[required()]}

                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                            <TextInput
                                source="industry"
                                fullWidth
                                validate={[required()]}

                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                            <TextInput
                                source="email"
                                fullWidth
                                validate={[required(), email()]}

                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={6}>
                            <DateTimeInput
                                source="data.registration_month"
                                locale={dateLocales}
                                providerOptions={{ locale: dateLocales, }}
                                options={defaultDateOptions}
                                InputProps={{
                                    readOnly: true,
                                }}
                                validate={[required()]}
                                show
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <JsonInput
                                source="data"
                                jsonString={false} // Set to true if the value is a string, default: false
                                reactJsonOptions={{
                                    // Props passed to react-json-view
                                    name: null,
                                    collapsed: true,
                                    enableClipboard: false,
                                    displayDataTypes: false,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <SemiControlledAccordion defaultOpen={!isMedium}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="other-info-panel"
                            id="other-info-panel"
                        >
                            <Typography variant="h6">{translate("resources.common.fieldGroups.accountInfo")}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReferenceManyInput
                                reference="merchant_banks"
                                target="merchant_id"
                            >
                                <MerchantBanks />
                            </ReferenceManyInput>
                        </AccordionDetails>
                    </SemiControlledAccordion>
                    <SemiControlledAccordion defaultOpen={!isMedium}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="other-info-panel"
                            id="other-info-panel"
                        >
                            <Typography variant="h6">{translate("resources.common.fieldGroups.phones")}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReferenceManyInput
                                reference="merchant_phones"
                                target="merchant_id"
                            >
                                <MerchantPhones />
                            </ReferenceManyInput>
                        </AccordionDetails>
                    </SemiControlledAccordion>
                    <SemiControlledAccordion defaultOpen={!isMedium}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="other-info-panel"
                            id="other-info-panel"
                        >
                            <Typography variant="h6">{translate("resources.common.fieldGroups.docs")}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReferenceManyInput
                                reference="merchant_docs"
                                target="merchant_id"
                                getMany
                            >
                                <MerchantDocs />
                            </ReferenceManyInput>
                        </AccordionDetails>
                    </SemiControlledAccordion>
                    {/* <Toolbar>
                        <Box display="flex" justifyContent="space-between" width="100%">
                            <SaveButton
                                saving={formProps.saving}
                                handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                            />
                            <DeleteButton record={formProps.record} />
                        </Box>
                    </Toolbar> */}
                </>
            )
        }}
    />
}

export default MerchantCommon